const getOptionText = (optionData) => optionData.get('text');
const getOptionId = (optionData) => optionData.get('id');

export {getOptionText, getOptionId}